import React from "react";
import styled from "styled-components";

const Square = styled.div`
  width: 60px;
  height: 60px;
  background-color: grey;
  opacity: 0.8;
  top: 0px;
  left: -60px;
  z-index: -1;
  position: absolute;
  animation: square 25s linear alternate infinite;
  @keyframes square {
    to {
      transform: translate(100vw, 100vh);
    }
  }
`;

const Triangle = styled.div`
  height: 100px;
  width: 50px;
  background-color: red;
  opacity: 0.5;
  animation: tringle 25s linear alternate infinite;
  position: absolute;
  z-index: -1;
  top: 150px;
  left: -500px;
  @keyframes tringle {
    to {
      transform: translate(100vw, 50vh);
    }
  }
`;

const Cercle = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: pink;
  animation: cercle 25s linear alternate infinite;
  position: absolute;
  z-index: -1;
  top: 300px;
  left: -125px;
  opacity: 0.7;
  @keyframes cercle {
    to {
      transform: translate(100vw, -50vh);
    }
  }
`;

const AnimatedShapes = () => {
  return (
    <>
      <Square />
      <Triangle />
      <Cercle />
    </>
  );
};

export default AnimatedShapes;
